import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';

type IProps = {
  defaultShow?: string;
  collection: JSX.Element;
  expense: JSX.Element;
  handlePrint: () => any;
};

const ShowingDatausingTab = ({
  defaultShow = 'collection',
  collection,
  expense,
  handlePrint,
}: IProps) => {
  const [currentTab, setCurrentTab] = useState(defaultShow);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={styles.container}>
          <div style={styles.tabList}>
            <button
              style={{
                ...styles.tab,
                borderBottom:
                  currentTab === 'collection'
                    ? '3px solid #1976d2'
                    : '3px solid transparent',
                color: currentTab === 'collection' ? '#1976d2' : '#666',
              }}
              onClick={() => setCurrentTab('collection')}
            >
              Collection
            </button>
            <button
              style={{
                ...styles.tab,
                borderBottom:
                  currentTab === 'expense'
                    ? '3px solid #1976d2'
                    : '3px solid transparent',
                color: currentTab === 'expense' ? '#1976d2' : '#666',
              }}
              onClick={() => setCurrentTab('expense')}
            >
              Expense
            </button>
          </div>
        </div>
        <span>
          <Button sx={{ background: '#DAE4F1' }} onClick={handlePrint}>
            Print
          </Button>
        </span>
      </div>

      <Box bgcolor={'#fff'}>
        {currentTab === 'collection' ? collection : expense}
      </Box>
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    maxWidth: '200px',
    borderRadius: '8px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#f9f9f9',
    marginBottom: '20px',
  },
  title: {
    textAlign: 'center' as const,
    fontWeight: '600',
    color: '#333',
    // marginBottom: '20px',
  },
  tabList: {
    display: 'flex',
    borderBottom: '1px solid #ddd',
    // marginBottom: '20px',
  },
  tab: {
    flex: 1,
    padding: '10px 10px',
    textAlign: 'center' as const,
    fontWeight: '500',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    transition: 'color 0.3s ease, border-bottom 0.3s ease',
  },
  panel: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
};

export default ShowingDatausingTab;
